import React, { useEffect, useRef } from 'react';
import { Checkbox, CircularProgress, TableBody, TableRow } from '@mui/material';
import { PAGINATION_LIMIT } from '@src/constants';
import List from 'rc-virtual-list';
import { StyledLoadingTable, StyledTableCell } from './index.style';

const TableBodyNew = ({
  flickerBackground,
  onChangePage,
  page,
  columns,
  data,
  selection,
  showNumber,
  isScrolling,
  isSelected,
  dropTable,
  loading,
  onSelectRow,
  onRowClick,
  isShowCheckbox,
}) => {
  const listRequestRef = useRef(null);
  const HEIGHT_LIST = 326;
  const HEIGHT_ITEM_REQUEST = 56;
  const handleRowClick = (rowId) => {
    if (onRowClick) onRowClick(rowId);
  };

  const onScrollVirtualList = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (!loading && scrollTop + clientHeight >= scrollHeight - 10) {
      onChangePage(page + 1, true);
    }
  };
  useEffect(() => {
    if (!flickerBackground || !listRequestRef?.current) return;
    listRequestRef.current.scrollTo(0, {
      behavior: 'smooth',
    });
  }, [flickerBackground, listRequestRef]);

  return (
    <TableBody>
      {loading && !isScrolling ? (
        <StyledLoadingTable dropTable={dropTable}>
          <TableRow className="body-row">
            <StyledTableCell>
              <CircularProgress />
            </StyledTableCell>
          </TableRow>
        </StyledLoadingTable>
      ) : (
        <List
          className="small-scrollbar"
          data={data}
          ref={listRequestRef}
          disabled={loading}
          height={data?.length > 5 && HEIGHT_LIST}
          itemHeight={HEIGHT_ITEM_REQUEST}
          itemKey="idVirtualList"
          onScroll={onScrollVirtualList}
        >
          {(rowData, index) => (
            <TableRow
              className="body-row"
              key={rowData.id}
              onClick={() => handleRowClick(rowData.id)}
            >
              {selection && isShowCheckbox && (
                <StyledTableCell
                  className="checkbox-cell"
                  padding="checkbox"
                  align="left"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Checkbox
                    className="body-checkbox"
                    checked={isSelected(rowData)}
                    onChange={onSelectRow(rowData)}
                  />
                </StyledTableCell>
              )}
              {showNumber && (
                <StyledTableCell className="body-cell" align="center">
                  {(page - 1) * PAGINATION_LIMIT + index + 1}
                </StyledTableCell>
              )}
              {columns.map((column) => (
                <StyledTableCell
                  width={column.width}
                  className="body-cell"
                  align={column.align}
                >
                  {column.render
                    ? column.render(rowData)
                    : rowData[column.field]}
                </StyledTableCell>
              ))}
            </TableRow>
          )}
        </List>
      )}
      {isScrolling ? (
        <div className="loading-infinite">
          <span class="loading__dot" />
          <span class="loading__dot" />
          <span class="loading__dot" />
        </div>
      ) : null}
    </TableBody>
  );
};

export default TableBodyNew;
